module.exports = __webpack_public_path__ + "static/media/delete.a4fb9444.svg";